var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTakeAway(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 96,
    viewBox: "0 0 72 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 6"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 149"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M66.1936 7.51172H5.80615V74.5451H66.1936V7.51172Z",
    fill: "#2E3F7F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M63.9083 8.44141H8.52734V70.5303H63.9083V8.44141Z",
    fill: "#11224C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M72 4.70312H0V8.4411H72V4.70312Z",
    fill: "#ED7C7C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M0 4.70352L11.2007 0H60.644L72 4.70352H0Z",
    fill: "#E35756"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    opacity: 0.3,
    d: "M5.80615 27.0815C5.80615 27.0815 31.244 4.42675 66.1936 27.0815V8.33984H5.80615V27.0815Z",
    fill: "#0A162D"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M70.7176 69.6846H1.28271V80.198H70.7176V69.6846Z",
    fill: "#838BDD"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    opacity: 0.43,
    d: "M19.4377 69.6848C19.4377 69.6848 16.2132 78.9591 15.7956 83.0769C15.378 87.1948 17.1133 88.6565 23.3452 90.9534C29.5772 93.2503 47.5834 95.3384 49.7518 95.1296C51.9202 94.9208 59.1143 94.5252 61.2853 91.042C63.4563 87.5589 26.2208 69.6846 26.2208 69.6846L19.4377 69.6848Z",
    fill: "#6771B7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M70.7176 76.4619H1.28271V80.1986H70.7176V76.4619Z",
    fill: "#6771B7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    opacity: 0.43,
    d: "M1.28271 80.1982C1.28271 80.1982 36.2072 90.4366 70.7176 80.1982H1.28271Z",
    fill: "#6771B7"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M31.7583 34.0357C31.7711 34.4633 32.6991 40.2363 32.6991 40.2363H37.1802C37.1802 40.2363 42.968 35.4747 42.6612 35.2433C42.3544 35.0119 37.556 28.2275 37.556 28.2275L31.7583 34.0357Z",
    fill: "#D38967"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M32.8413 12.0287C32.8413 12.0287 32.8973 11.2198 33.5337 11.1427C34.1701 11.0655 34.8732 11.4882 34.6948 12.5481C34.6948 12.5481 33.7189 12.1525 32.8413 12.0287Z",
    fill: "#E35756"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M25.2743 30.4093C25.3037 30.5295 24.748 33.0665 26.2206 33.0961C27.6932 33.1255 28.1357 34.6301 28.9911 33.2732C29.8465 31.9162 26.5131 29.9102 26.5131 29.9102L25.2743 30.4093Z",
    fill: "#895C43"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M41.4401 25.6865C41.4401 25.6865 42.5318 27.0775 41.7944 27.2842C41.0569 27.4906 41.9148 29.7986 39.5832 29.087C37.2516 28.3756 40.2015 26.2515 40.2015 26.2515L41.4401 25.6865Z",
    fill: "#895C43"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M26.7709 26.1099C26.4496 26.0296 22.7551 24.8248 21.149 26.1099C19.5428 27.3949 19.9444 31.3303 26.7709 30.6074C33.5977 29.8848 26.7709 26.1099 26.7709 26.1099Z",
    fill: "#D38967"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    d: "M38.6742 20.9726C38.6742 20.9726 36.718 15.8862 29.8056 16.7991C22.8931 17.712 22.9225 25.5204 25.1756 29.3849C27.2332 32.9143 30.1967 35.319 33.8486 34.5366C37.5005 33.7541 39.7827 30.037 40.2393 26.5157C40.2393 26.5157 43.1738 24.9507 43.8912 22.1465C44.6083 19.3423 40.8912 16.5381 38.6742 20.9726Z",
    fill: "#E3A382"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_16",
    d: "M32.8767 24.6949C32.9962 25.2262 33.3876 25.591 33.7506 25.5091C34.1137 25.4275 34.3112 24.9305 34.1916 24.3989C34.0721 23.8676 33.6807 23.5031 33.3177 23.5847C32.9547 23.6665 32.7572 24.1635 32.8767 24.6949Z",
    fill: "#65343B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_17",
    d: "M27.1697 25.9926C27.2892 26.5239 27.6806 26.8884 28.0436 26.8068C28.4066 26.7252 28.6041 26.2282 28.4846 25.6968C28.3651 25.1655 27.9737 24.8007 27.6107 24.8826C27.2474 24.9642 27.0502 25.4612 27.1697 25.9926Z",
    fill: "#65343B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_18",
    d: "M34.695 28.5156C34.695 28.5156 32.4267 30.3419 30.1055 30.3067",
    stroke: "#65343B",
    strokeWidth: 0.27443,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_19",
    d: "M30.3077 23.1152C30.2666 23.2203 29.499 27.5418 31.0871 28.3563",
    stroke: "#C86945",
    strokeWidth: 0.27443,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_20",
    d: "M39.9469 19.2696C39.6746 18.8929 39.4432 13.2835 32.8417 12.0291C26.2401 10.7749 21.5658 17.0311 22.585 24.5469C22.585 24.5469 22.8528 20.3822 28.5199 19.9904C34.1871 19.5984 38.6741 20.973 38.6741 20.973L39.9469 19.2696Z",
    fill: "#F0AF46"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_21",
    d: "M16.7168 21.9449V20.9791C16.7168 20.6864 16.7754 20.3952 16.9004 20.1304C17.2829 19.3214 18.7659 17.6223 21.9406 17.1464C26.336 16.4876 29.1389 17.4608 38.8485 20.7384L38.6738 20.9721C38.6738 20.9721 29.5518 18.1982 24.1533 18.8472C18.7551 19.4965 16.7168 21.9449 16.7168 21.9449Z",
    fill: "#A02020"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_22",
    d: "M38.6741 20.9722C38.6741 20.9722 33.5719 19.0763 27.135 17.6719C20.6981 16.2676 17.0386 19.4189 16.7335 21.5539C16.4286 23.6886 20.3575 26.2829 23.935 25.6453C23.935 25.6453 23.0583 20.9428 27.135 20.1782C31.4644 19.3665 38.6741 20.9722 38.6741 20.9722Z",
    fill: "#E35756"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_23",
    d: "M30.5872 19.9197C30.5872 19.9197 26.0765 25.5385 24.3308 25.0425C24.3308 25.0425 23.8883 24.8064 24.3308 23.9804C24.3308 23.9804 23.1509 25.5764 22.2953 25.0734C21.4397 24.5704 21.8822 22.5645 23.1803 21.7679C23.1803 21.7679 21.7054 20.2857 24.1833 19.4486C26.6611 18.6118 30.5872 19.9197 30.5872 19.9197Z",
    fill: "#895C43"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_24",
    d: "M30.5872 19.92C30.5872 19.92 33.3281 22.3584 37.3105 22.152C37.3105 22.152 38.2545 24.1874 39.1689 24.1284C40.0833 24.0694 39.1985 22.1707 39.1985 22.1707L38.6742 20.9729C38.6742 20.9729 29.4391 18.4585 26.2212 19.1697",
    fill: "#895C43"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_25",
    d: "M23.8946 23.6904C23.8946 23.6904 23.7659 25.7404 24.2302 27.0816L23.062 24.689L23.8946 23.6904Z",
    fill: "#895C43"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_26",
    d: "M32.0949 36.1338L29.6851 36.8648C28.0915 37.3482 26.804 38.53 26.1864 40.0767L21.4087 52.0423L27.3537 59.0367L36.828 42.7166L32.0949 36.1338Z",
    fill: "#F0AF46"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_27",
    d: "M40.6357 33.1472C40.6357 33.1472 41.767 30.3085 45.5502 29.4118C49.3333 28.5152 56.5398 29.5095 58.2883 37.8096C60.0368 46.1096 40.6357 33.1472 40.6357 33.1472Z",
    fill: "#F0AF46"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_28",
    d: "M44.6226 32.3832C44.7235 32.4362 52.4066 29.3838 55.9568 36.8711C55.9568 36.8711 44.8243 32.489 44.7235 32.4362",
    fill: "#D38967"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_29",
    d: "M24.9711 54.9452C24.0105 55.602 55.661 64.4372 64.2953 60.7344C64.2953 60.7344 36.5713 47.0152 24.9711 54.9452Z",
    fill: "#5E3C2B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_30",
    d: "M26.777 52.9254L19.2337 78.5565C17.7044 83.7528 21.1635 89.0906 26.5313 89.8173L53.8783 93.5197C59.2467 94.2464 64.0012 90.0195 63.9074 84.6026L63.4112 55.9252C63.4112 55.9252 42.8465 40.8408 26.777 52.9254Z",
    fill: "#9E6B51"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_31",
    d: "M35.7025 44.1434H29.5411C27.6599 44.1434 26.0765 45.5514 25.8566 47.4199L24.9712 54.9453C24.9712 54.9453 35.42 50.2151 64.2954 60.7345L66.0531 52.6916C66.3942 51.1312 65.5629 49.5491 64.0811 48.953C59.4581 47.0935 48.9234 43.6229 35.7025 44.1434Z",
    fill: "#895C43"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_32",
    d: "M39.1177 87.0009C46.6224 88.0998 53.6224 82.8884 54.7213 75.3837C55.8202 67.8788 50.6084 60.879 43.1037 59.7801C35.599 58.6812 28.5992 63.8928 27.5003 71.3977C26.4014 78.9026 31.613 85.902 39.1177 87.0009Z",
    fill: "#E35756"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_33",
    d: "M39.4634 84.6408C33.2596 83.7324 28.9513 77.9463 29.8597 71.7434C30.7682 65.5393 36.5546 61.231 42.7584 62.1395C48.962 63.0479 53.2701 68.8344 52.3615 75.0384C51.453 81.2412 45.667 85.5493 39.4634 84.6408Z",
    fill: "#F0AF46"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_34",
    d: "M45.1134 82.2101C49.9853 80.0014 52.1443 74.2616 49.9357 69.3897C47.7271 64.5178 41.9872 62.3587 37.1153 64.5674C32.2434 66.776 30.0844 72.5159 32.293 77.3878C34.5016 82.2597 40.2415 84.4187 45.1134 82.2101Z",
    fill: "#415099"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_8"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_35",
    d: "M47.0924 72.4613L35.6416 70.7846L35.7699 69.9083C36.1011 67.6451 38.2046 66.0791 40.4678 66.4104L43.723 66.887C45.9863 67.2185 47.5522 69.3218 47.2209 71.585L47.0924 72.4613Z",
    fill: "#E3A382"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_36",
    d: "M35.2747 73.3086L46.7256 74.9853L46.5973 75.8616C46.2658 78.1248 44.1626 79.6907 41.8993 79.3594L38.6441 78.8828C36.3809 78.5516 34.815 76.4481 35.1463 74.1849L35.2747 73.3086Z",
    fill: "#E3A382"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_37",
    opacity: 0.17,
    d: "M35.1084 74.9961C35.1597 76.0273 35.5982 76.9777 36.2955 77.6876C38.2522 77.8216 38.1363 76.7687 40.0552 77.9824C42.1734 79.3221 43.6279 78.9861 44.0365 78.4281C44.1522 78.27 44.6064 78.332 45.135 78.4509C45.4053 78.2276 45.6487 77.9718 45.8559 77.685L35.1084 74.9961Z",
    fill: "#E3A382"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_10"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_38",
    d: "M46.4754 76.6521L35.0312 74.9762C34.4526 74.8915 34.052 74.3537 34.1368 73.7749C34.2216 73.1962 34.7593 72.7957 35.3382 72.8805L46.7824 74.5563C47.3611 74.6411 47.7616 75.1789 47.6768 75.7577C47.5918 76.3364 47.0541 76.7369 46.4754 76.6521Z",
    fill: "#956A69"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_39",
    d: "M46.7825 74.5563L35.3383 72.8805C34.8325 72.8063 34.3583 73.1029 34.1899 73.565C35.8306 73.5034 39.5965 73.6394 47.6841 75.5939C47.6797 75.0811 47.306 74.633 46.7825 74.5563Z",
    fill: "#825555"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_40",
    d: "M46.7821 74.5562L35.3378 72.8803C34.7592 72.7955 34.3587 72.2578 34.4435 71.6791C34.5282 71.1005 35.066 70.7 35.6448 70.7848L47.0891 72.4606C47.6677 72.5454 48.0683 73.0832 47.9835 73.662C47.8987 74.2404 47.3607 74.6408 46.7821 74.5562Z",
    fill: "#956A69"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_41",
    d: "M47.0887 72.4606L35.6444 70.7848C35.1387 70.7106 34.6644 71.0072 34.4961 71.4693C36.1368 71.4077 39.9027 71.5437 47.9903 73.4982C47.986 72.9852 47.6121 72.5373 47.0887 72.4606Z",
    fill: "#825555"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_42",
    d: "M35.4165 72.8926C35.4165 72.8926 37.3619 76.4192 41.2228 73.7429L35.4165 72.8926Z",
    fill: "#E35756"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_43",
    d: "M40.9795 73.707C40.9795 73.707 42.9249 77.2337 46.7858 74.5573L40.9795 73.707Z",
    fill: "#E35756"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_44",
    d: "M35.0311 74.9766C35.0311 74.9766 33.1041 76.0003 35.7896 76.4622C38.4751 76.9241 38.105 75.497 40.2232 76.8369C42.3413 78.1766 43.7958 77.8406 44.2044 77.2826C44.6131 76.7248 49.2327 78.9073 46.4756 76.6524L35.0311 74.9766Z",
    fill: "#CBD177"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_45",
    d: "M38.4595 73.3379C38.4595 73.3379 41.423 74.4074 41.72 77.0409C41.72 77.0409 44.544 76.0387 44.8062 74.2674L38.4595 73.3379Z",
    fill: "#F0AF46"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_46",
    opacity: 0.39,
    d: "M39.5028 68.5038L39.3498 68.4815C39.2898 68.4727 39.2478 68.4163 39.2565 68.3562C39.2653 68.2961 39.3217 68.2541 39.3818 68.2629L39.5348 68.2852C39.5948 68.294 39.6368 68.3504 39.6281 68.4105C39.6193 68.4706 39.5629 68.5126 39.5028 68.5038Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_47",
    opacity: 0.39,
    d: "M41.8202 67.2021L41.6672 67.1797C41.6071 67.171 41.5652 67.1145 41.5739 67.0544C41.5826 66.9944 41.6391 66.9524 41.6992 66.9611L41.8521 66.9835C41.9122 66.9922 41.9542 67.0487 41.9455 67.1088C41.9365 67.1688 41.8803 67.2108 41.8202 67.2021Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_48",
    opacity: 0.39,
    d: "M42.5746 68.1581L42.4216 68.1358C42.3615 68.127 42.3196 68.0706 42.3283 68.0105C42.337 67.9504 42.3935 67.9084 42.4536 67.9172L42.6065 67.9395C42.6666 67.9483 42.7086 68.0047 42.6999 68.0648C42.6911 68.1249 42.6349 68.1669 42.5746 68.1581Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_49",
    opacity: 0.39,
    d: "M43.6967 67.4765L43.5437 67.4541C43.4836 67.4454 43.4416 67.3889 43.4504 67.3288C43.4591 67.2688 43.5156 67.2268 43.5756 67.2355L43.7286 67.2579C43.7887 67.2666 43.8307 67.3231 43.8219 67.3832C43.8132 67.4435 43.7567 67.4854 43.6967 67.4765Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_50",
    opacity: 0.39,
    d: "M45.0365 68.081L44.8835 68.0586C44.8235 68.0499 44.7815 67.9934 44.7902 67.9333C44.7989 67.8733 44.8554 67.8313 44.9155 67.84L45.0685 67.8624C45.1285 67.8711 45.1705 67.9276 45.1618 67.9877C45.153 68.0477 45.0966 68.0897 45.0365 68.081Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_51",
    opacity: 0.39,
    d: "M45.6234 68.7167L45.4704 68.6943C45.4104 68.6856 45.3684 68.6292 45.3771 68.5691C45.3859 68.509 45.4423 68.467 45.5024 68.4758L45.6554 68.4981C45.7155 68.5069 45.7574 68.5633 45.7487 68.6234C45.74 68.6837 45.6837 68.7257 45.6234 68.7167Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_52",
    opacity: 0.39,
    d: "M44.141 68.7226L43.988 68.7002C43.9279 68.6915 43.886 68.635 43.8947 68.5749C43.9034 68.5149 43.9599 68.4729 44.02 68.4816L44.1729 68.504C44.233 68.5127 44.275 68.5692 44.2663 68.6293C44.2573 68.6896 44.2011 68.7315 44.141 68.7226Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_53",
    opacity: 0.39,
    d: "M41.0931 68.7372L40.9402 68.7149C40.8801 68.7061 40.8381 68.6497 40.8469 68.5896C40.8556 68.5295 40.912 68.4875 40.9721 68.4963L41.1251 68.5186C41.1852 68.5274 41.2272 68.5838 41.2184 68.6439C41.2097 68.704 41.1534 68.746 41.0931 68.7372Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_54",
    opacity: 0.39,
    d: "M42.7352 69.0888L42.5823 69.0664C42.5222 69.0577 42.4802 69.0012 42.4889 68.9411C42.4977 68.8811 42.5541 68.8391 42.6142 68.8478L42.7672 68.8702C42.8273 68.8789 42.8692 68.9354 42.8605 68.9955C42.8518 69.0556 42.7953 69.0975 42.7352 69.0888Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_55",
    opacity: 0.39,
    d: "M40.5658 67.7529L40.4128 67.7305C40.3527 67.7217 40.3108 67.6653 40.3195 67.6052C40.3282 67.5451 40.3847 67.5032 40.4448 67.5119L40.5978 67.5343C40.6578 67.543 40.6998 67.5995 40.6911 67.6595C40.6823 67.7196 40.6259 67.7616 40.5658 67.7529Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_56",
    opacity: 0.39,
    d: "M39.8578 66.915L39.7048 66.8926C39.6447 66.8839 39.6028 66.8274 39.6115 66.7673C39.6202 66.7072 39.6767 66.6653 39.7368 66.674L39.8897 66.6964C39.9498 66.7051 39.9918 66.7616 39.9831 66.8216C39.9743 66.8817 39.9179 66.9239 39.8578 66.915Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_57",
    opacity: 0.39,
    d: "M38.6239 67.4687L38.4709 67.4463C38.4108 67.4376 38.3689 67.3811 38.3776 67.321C38.3864 67.261 38.4428 67.219 38.5029 67.2277L38.6559 67.2501C38.7159 67.2588 38.7579 67.3153 38.7492 67.3754C38.7404 67.4356 38.6842 67.4776 38.6239 67.4687Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_58",
    d: "M60.6949 44.7078C60.6949 44.7078 62.7423 39.9069 59.2122 37.5772C55.6822 35.2475 56.1765 37.5772 54.1291 35.1768C52.0817 32.7764 50.105 34.5415 48.1986 33.4117C46.2924 32.2821 44.9511 30.8018 42.2681 32.0009C39.5854 33.1999 39.5147 31.576 36.5494 33.8352C33.5842 36.0944 32.8076 39.8362 32.8076 43.3662C32.8076 46.8963 33.9372 53.1798 34.9255 54.5211C35.9139 55.8625 37.8908 56.498 39.0909 55.0154C39.0909 55.0154 41.0678 60.0986 44.5976 56.8511C44.5976 56.8511 46.5745 59.2515 49.7515 56.4275C49.7515 56.4275 52.0107 58.5455 54.6934 55.2979C57.3766 52.0504 60.6949 44.7078 60.6949 44.7078Z",
    fill: "#E3A382"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_59",
    d: "M39.0913 55.0153C39.0913 55.0153 37.75 45.4843 39.5856 36.8711C39.5856 36.8711 36.209 49.1647 37.4031 55.8671C37.4031 55.8671 38.4558 56.0039 39.0913 55.0153Z",
    fill: "#D38967"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_60",
    d: "M44.598 56.8513C44.598 56.8513 45.7276 42.3076 46.5042 38.707C46.5042 38.707 43.4322 51.7349 43.7326 57.5053L44.598 56.8513Z",
    fill: "#D38967"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_61",
    d: "M49.752 56.4277C49.752 56.4277 52.3642 45.5553 53.282 40.8252C53.282 40.8252 51.5627 53.5959 50.5867 56.918L49.752 56.4277Z",
    fill: "#D38967"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_13"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_62",
    d: "M16.6458 54.5762L14.3399 50.9669C14.3399 50.9669 13.2704 49.7638 11.9672 50.7329C11.9672 50.7329 11.5662 51.0672 12.2011 51.9695C12.836 52.8717 15.1755 57.6507 15.1755 57.6507L16.6458 54.5762Z",
    fill: "#C47657"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_14"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_63",
    d: "M24.7641 56.6651L18.9619 59.7907L10.7637 47.1828L18.7456 42.8828L24.7641 56.6651Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_64",
    d: "M12.5159 40.9295L11.9209 41.25L13.9867 45.0845L14.5816 44.764L12.5159 40.9295Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_65",
    d: "M12.5965 41.5443L7.62266 42.3769L7.53467 41.7537L12.5085 40.9209L12.5965 41.5443Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_66",
    d: "M18.8538 42.0094L10.0288 46.7637L10.6699 47.9536L19.4948 43.1993L18.8538 42.0094Z",
    fill: "#F0AF46"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_67",
    opacity: 0.31,
    d: "M24.7639 56.6652L21.39 48.9391C20.7652 49.336 21.4891 47.8255 19.1664 47.9065C16.8335 47.9879 14.4207 51.4109 13.9595 52.0978L18.9619 59.7906L24.7639 56.6652Z",
    fill: "#838BDD"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_68",
    d: "M13.9724 54.9445C14.2063 53.0731 15.8439 50.767 18.0161 49.2965C20.1884 47.826 20.6562 49.497 20.2218 50.6C20.2218 50.6 21.1477 49.3259 22.5062 49.2946C23.8646 49.2633 22.7284 51.8316 22.7284 51.8316C22.7284 51.8316 24.2657 51.4353 23.9649 53.7079C23.9649 53.7079 25.7028 53.891 24.6667 57.0577C23.6306 60.2247 20.9236 62.5975 20.0213 62.4639C19.1191 62.3301 13.0642 62.2116 13.9724 54.9445Z",
    fill: "#D38C6C"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_69",
    d: "M20.2218 50.6C20.2218 50.6 17.8947 52.7318 16.646 55.4156C16.646 55.4156 17.9644 52.1557 20.3599 49.6543C20.3599 49.6543 20.4025 50.0363 20.2218 50.6Z",
    fill: "#C47657"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_70",
    d: "M22.7283 51.8311C22.7283 51.8311 20.584 54.9324 19.438 56.6816C19.438 56.6816 21.8067 52.0209 23.1555 50.3555C23.1555 50.3555 22.9591 51.4966 22.7283 51.8311Z",
    fill: "#C47657"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_71",
    d: "M23.965 53.708C23.965 53.708 22.8761 56.4798 22.2729 57.6516C22.2729 57.6516 23.9102 55.4942 24.4184 53.9019C24.4184 53.9019 24.3604 53.8096 23.965 53.708Z",
    fill: "#C47657"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_72",
    d: "M16.8182 54.1973H8.98284L8.13916 69.6845H17.6791L16.8182 54.1973Z",
    fill: "#E35756"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_73",
    d: "M8.98307 54.1973H16.8184L8.77002 58.7653L8.98307 54.1973Z",
    fill: "#C63838"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_74",
    d: "M17.4954 52.1396H8.30566V54.4815H17.4954V52.1396Z",
    fill: "#E35756"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_75",
    d: "M14.5433 52.8363H11.2578L12.11 46.5615H13.6911L14.5433 52.8363Z",
    fill: "#E35756"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_76",
    d: "M14.4178 52.14H11.3496L11.643 49.9795L14.4178 52.14Z",
    fill: "#C63838"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_16"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_77",
    d: "M9.13128 57.6348H3.03803L2.38184 69.6785H9.80068L9.13128 57.6348Z",
    fill: "#F0AF46"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_78",
    d: "M3.03782 57.6348H9.13107L2.87207 61.1872L3.03782 57.6348Z",
    fill: "#D8932E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_79",
    d: "M9.6578 56.0352H2.51123V57.8563H9.6578V56.0352Z",
    fill: "#F0AF46"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_80",
    d: "M7.36203 56.577H4.80713L5.46972 51.6973H6.69923L7.36203 56.577Z",
    fill: "#F0AF46"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_81",
    d: "M7.26437 56.0356H4.87842L5.10659 54.3555L7.26437 56.0356Z",
    fill: "#D8932E"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTakeAway);
export default __webpack_public_path__ + "static/media/takeAway.ecee0db9dc62e19f03a61c73fe74f8f0.svg";
export { ForwardRef as ReactComponent };